<template>
  <v-container fluid>
    <v-layout column>
      <!-- TITLE -->
      <v-flex class="section-1 general-bg" pa-3 d-flex>
        <v-flex pa-3>
          <h2>KPI - Indicadores de gestión</h2>
        </v-flex>
      </v-flex>
      <v-flex d-flex mt-2>
        <v-flex
          v-if="agenciesTree.length > 0"
          class="section-2 general-bg"
        >
          <v-flex pa-3>
            <h3>Listado Agencias</h3>
            <p class="caption">Seleccione una Agencia para poder visualizar los datos.</p>
          </v-flex>
          <!-- AGENCIES TREE -->
          <v-flex v-if="agenciesTree.length > 0" mb-3>
            <v-flex v-show="!isLoadingData">
              <agencies-tree
                from-section="kpi"
                @load-agency-data="loadAgencyData"
              />
            </v-flex>
            <!-- LOADING -->
            <v-flex
              v-if="isLoadingData"
              pl-3
              pt-5
              mt-5
            >
              <v-flex class="caption">
                Cargando y procesando datos de:
              </v-flex>
              <h3>
                {{ 
                  agencyParent === currentAgency.name
                    ? agencyParent
                    : `${agencyParent} | ${currentAgency.name}`
                }}
              </h3>
              <v-progress-circular
                :size="28"
                :width="3"
                color="primary"
                indeterminate
              />
              <!-- <br> -->
              <v-flex mt-2>
                <v-btn small color="error" @click="cancelRequest">
                  Cancelar Proceso
                </v-btn>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- LOADING -->
        <v-flex
          v-else
          class="section-2 general-bg"
          pa-3
        >
          <h3>Cargando y procesando datos...</h3>
          <v-progress-circular
            :size="28"
            :width="3"
            color="primary"
            indeterminate
          />
        </v-flex>
        <!-- GRAPHIC SECTION -->
        <v-flex
          v-if="agencySelected"
          class="section-3 general-bg"
          pa-3
        >
          <!-- TITLE -->
          <v-layout column>
            <h3>Datos Agencia</h3>
            <v-flex
              v-if="agencyParent !== agencySelected"
              class="subheading font-weight-medium"
              mt-1
              mb-0
            >
              {{ agencyParent }}
            </v-flex>
            <v-flex class="display-1 font-weight-medium" mt-0 mb-2>
              {{ agencySelected }}
            </v-flex>
          </v-layout>
          <!-- CONTENT -->
          <v-layout>
            <!-- STATUS VEHICLE -->
            <v-flex xs6>
              <h3>Condición Vehículos</h3>
              <!-- DATE & TIME -->
              <v-flex class="caption">
                {{ `Procesado el: ${dateAndTimeStatus}` }}
              </v-flex>
              <!-- RELOAD BUTTON -->
              <v-flex>
                Actualizar Datos
                <v-btn
                  color="white"
                  flat
                  icon
                  @click="loadStatusData(currentAgency)"
                >
                  <v-icon>update</v-icon>
                </v-btn>
              </v-flex>
              <!-- VEHICLES FOUND -->
              <v-flex v-if="statusVehiclesC.length > 0">
                <!-- PIE GRAPHIC -->
                <v-flex py-3>
                  <pie
                    :data='statusVehiclesC'
                    :color='colorSchemeStatus'
                    graphicType="status"
                    @set-color="setColor"
                  />
                </v-flex>
                <!-- DATA LIST -->
                <v-flex
                  v-for="(item, index) in statusVehiclesC"
                  :key="index"
                  class="subheading"
                  pl-2
                >
                  <v-flex v-if="colorMapStatus !== null">
                    <v-icon
                      :color="colorMapStatus.get(item.label)"
                    >
                      lens
                    </v-icon>
                    {{ `${item.label} : ${item.value}`}}
                  </v-flex>
                </v-flex>
                <v-flex
                  v-if="totalStatusVehicle > 0"
                  class="title"
                  style="padding-left:40px;"
                  mt-2
                >
                  Total: {{ totalStatusVehicle }}
                </v-flex>
              </v-flex>
              <!-- ZERO VEHICLES -->
              <v-flex v-else>
                <v-icon>warning</v-icon>
                <v-flex class="caption font-italic">
                  No hay datos para graficar debido a que no se encontraron vehículos asociados a la agencia seleccionada:
                </v-flex>
                <h3>
                  {{ 
                    agencyParent === currentAgency.name
                      ? agencyParent
                      : `${agencyParent} | ${currentAgency.name}`
                  }}
                </h3>
              </v-flex>
            </v-flex>
            <!-- VEHICLES IN MISSION -->
            <v-flex xs6>
              <h3>Vehículos en Misión</h3>
              <div v-if="inMissionLoaded">
                <!-- DATE & TIME -->
                <v-flex v-if="!requestCanceled" class="caption">
                  {{ `Procesado el: ${dateAndTimeInMission}` }}
                </v-flex>
                <v-flex v-else class="cancel-message">
                  Proceso cancelado por el usuario!
                </v-flex>
                <!-- RELOAD BUTTON -->
                <v-flex>
                  Actualizar Datos
                  <v-btn
                    color="white"
                    flat
                    icon
                    @click="loadInMissionData(currentAgency)"
                  >
                    <v-icon>update</v-icon>
                  </v-btn>
                </v-flex>
                <!-- VEHICLES FOUND -->
                <v-flex v-if="missionVehiclesC.length > 0">
                  <div v-if="!requestCanceled">
                    <!-- PIE GRAPHIC -->
                    <v-flex py-3>
                      <pie
                        :data='missionVehiclesC'
                        :color='colorSchemeMission'
                        graphicType="mission"
                        @set-color="setColor"
                      />
                    </v-flex>
                    <!-- DATA LIST -->
                    <v-flex
                      v-for="(item, index) in missionVehiclesC"
                      :key="index"
                      class="subheading"
                      pl-2
                    >
                      <v-flex v-if="colorMapMission !== null">
                        <v-icon
                          :color="colorMapMission.get(item.label)"
                        >
                          lens
                        </v-icon>
                        {{ `${item.label} : ${item.value}`}}
                      </v-flex>
                    </v-flex>
                    <!-- TOTAL -->
                    <v-flex
                      v-if="totalMissionVehicles > 0"
                      class="title"
                      style="padding-left:40px;"
                      mt-2
                    >
                      Total: {{ totalMissionVehicles }}
                    </v-flex>
                  </div>
                </v-flex>
                <!-- ZERO VEHICLES -->
                <v-flex v-else>
                  <v-flex v-if="!requestCanceled">
                    <v-icon>warning</v-icon>
                    <v-flex class="caption font-italic">
                      No hay datos para graficar debido a que no hay vehículos asociados a la agencia seleccionada:
                    </v-flex>
                    <h3>
                      {{ 
                        agencyParent === currentAgency.name
                          ? agencyParent
                          : `${agencyParent} | ${currentAgency.name}`
                      }}
                    </h3>
                  </v-flex>
                </v-flex>
              </div>
              <!-- LOADING -->
              <div v-else>
                <div class="caption">Cargando y procesando datos...</div>
                <v-progress-circular
                  :size="28"
                  :width="3"
                  color="primary"
                  indeterminate
                />
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pie from './Pie'
import AgenciesTree from '@/components/AgenciesTree'

const colorSchemeMapStatus = new Map([
  [0, ['#B39E15', '#3FE63E', '#51E0FC']],
  [1, ['#17CFFF', '#6C8E96', '#51FCC0']],
  [2, ['#FF6D53', '#643EE6', '#51FCC0']],
  [3, ['#FF80EE', '#3E56E6', '#51FCC0']],
  [4, ['#8B88FF', '#3EAAE6', '#51FCC0']],
  [5, ['#86E9FF', '#FC6AA2', '#2995FF']],
  [6, ['#98FFAF', '#497552', '#7ADB30']]
])
const colorSchemeMapMission = new Map([
  [0, ['#6C3EE6', '#FE4571']],
  [1, ['#FD9590', '#C92C64']],
  [2, ['#E6DA3E', '#FFA653']],
  [3, ['#9AEB87', '#FEB744']],
  [4, ['#4EE63E', '#FDFE44']],
  [5, ['#FCEB38', '#B0A430']],
  [6, ['#B869E0', '#4E14A8']]
])

export default {
  name: 'k-p-i',
  components: {
    Pie,
    AgenciesTree
  },
  data() {
    return {
      colorSchemeMapStatus,
      colorSchemeStatus: [],
      // resultStatusWorker: {},
      workerProcess: null,
      agencySelected: '',
      fromSection: 'KPI',
      statusVehicles: [],
      colorMapStatus: null,
      inMissionLoaded: true,
      missionVehicles: [],
      colorSchemeMapMission,
      colorSchemeMission: [],
      colorMapMission: null,
      dateAndTimeStatus: '',
      dateAndTimeInMission: '',
      currentAgency: null,
      currentIndex: null,
      isLoadingData: false,
      isLoading: 'is-loading',
      agencyParent: '',
      requestCanceled: false
    }
  },
  watch: {
    inMissionDataFullKPI(newValue, oldValue) {
      // console.log('inMissionDataFullKPI', newValue, oldValue)
      if (newValue.length > 0) this.inMissionLoaded = true
    }
  },
  computed: {
    ...mapGetters([
      'lastPositionsInit',
      'agenciesMapObj',
      'agenciesBase',
      'agenciesTree',
      'inMissionDataFullKPI',
      'cancelTokenInMissionData'
    ]),
    totalStatusVehicle() {
      let total = 0
      this.statusVehicles.forEach(element => {
        total = total + element.value
      })
      return total
    },
    statusVehiclesC() {
      return this.statusVehicles
    },
    missionVehiclesC() {
      return this.missionVehicles
    },
    totalMissionVehicles() {
      let total = 0
      this.missionVehicles.forEach(element => {
        total = total + element.value
      })
      return total
    }
  },
  methods: {
    ...mapActions(['getInMissionDataKPI', 'getStaticHeatmap']),
    loadAgencyData(agency) {
      this.statusVehicles = []
      this.missionVehicles = []
      this.currentIndex = Math.floor(Math.random() * Math.floor(7))
      // console.log('AGENCY: ', agency)
      this.currentAgency = agency
      const parentId = this.agenciesMapObj[this.currentAgency.id].superParentId
      this.agencyParent = this.agenciesMapObj[parentId].name
      this.loadStatusData(agency)
      this.loadInMissionData(agency)
    },
    loadStatusData(agency) {
      this.statusVehicles = []
      this.colorSchemeStatus = this.colorSchemeMapStatus.get(this.currentIndex)
      this.agencySelected = agency.name
      this.workerProcess.postMessage(
        'dataStatus',
        [
          agency.id,
          this.lastPositionsInit,
          this.agenciesMapObj,
          agency.agencyIds
        ])
        .then(resultStatusData => {
          // this.resultStatusWorker = resultDSC
          // STATUS VEHICLES
          this.statusVehicles = []
          if (resultStatusData.operative > 0) this.statusVehicles.push({ label: 'Operativo', value: resultStatusData.operative })
          if (resultStatusData.notOperative > 0) this.statusVehicles.push({ label: 'No operativo', value: resultStatusData.notOperative })
          if (resultStatusData.unknown > 0) this.statusVehicles.push({ label: 'Por identificar', value: resultStatusData.unknown })
          // DATE & TIME
          const dateAndTimeTemp = this.$moment.now()
          this.dateAndTimeStatus = this.$moment(dateAndTimeTemp).format('DD/MM/YYYY HH:mm:ss')
        })
        .catch(error => {
          console.error('WORKER ERROR - worker: workerProcess- STATUS:', error)
        })
    },
    async loadInMissionData(agency) {
      this.missionVehicles = []
      this.requestCanceled = false
      this.inMissionLoaded = false
      this.isLoadingData = true
      const response = await this.getInMissionDataKPI()
      // console.log('RESPONSE async await loadInMissionData:', response)
      if (response === 'error') {
        // console.log('ERROR response')
        this.inMissionLoaded = true
        this.requestCanceled = true
        this.isLoadingData = false
        return
      }
      this.colorSchemeMission = this.colorSchemeMapMission.get(this.currentIndex)
      this.agencySelected = agency.name
      this.workerProcess.postMessage(
        'dataInMission',
        [
          agency.id,
          this.inMissionDataFullKPI,
          this.agenciesMapObj,
          agency.agencyIds
        ])
        .then(resultInMissionData => {
          // this.resultStatusWorker = resultDSC
          // VEHICLES IN MISSION
          this.missionVehicles = []
          if (resultInMissionData.unassigned > 0) this.missionVehicles.push({ label: 'Sin asignar', value: resultInMissionData.unassigned })
          if (resultInMissionData.inMission > 0) this.missionVehicles.push({ label: 'En servicio', value: resultInMissionData.inMission })
          // DATE & TIME
          const dateAndTimeTemp = this.$moment.now()
          this.dateAndTimeInMission = this.$moment(dateAndTimeTemp).format('DD/MM/YYYY HH:mm:ss')
          this.isLoadingData = false
        })
        .catch(error => {
          console.error('WORKER ERROR - worker: workerProcess- IN MISSION:', error)
        })
    },
    setColor(data) {
      const colorSet = []
      for (let index = 0; index < data.colors.length; index++) {
        const color = data.colors[index]
        const label = data.data[index].label
        colorSet.push([label, color])
      }
      if (data.graphicType === 'status') this.colorMapStatus = new Map(colorSet)
      else if (data.graphicType === 'mission') this.colorMapMission = new Map(colorSet)
    },
    cancelRequest() {
      this.cancelTokenInMissionData.cancel()
      this.requestCanceled = true
    }
    // async getHeatmap() {
    //   this.heatMapDialog = true
    //   const result = await this.getStaticHeatmap('2021-11-22')
    //   console.log('RESULT getHeatmap', result)
    //   this.url = result.data.url
    // },
    // closeHeatMapDialog() {
    //   this.heatMapDialog = false
    // }
  },
  created() {
    const workerProcessIn = [
      {
        message: 'dataStatus',
        func: (agency, lastPositionsInit, agenciesMapObj, agenciesIds) => {
          const operativeArray = []
          const notOperativeArray = []
          const unknownArray = []

          agenciesIds.push(agency)

          for (let index = 0; index < lastPositionsInit.length; index++) {
            const element = lastPositionsInit[index]

            // const match = agenciesMapObj[element.agencyId].superParentId === agency
            let match = false
            for (let indexIds = 0; indexIds < agenciesIds.length; indexIds++) {
              const elementId = agenciesIds[indexIds]
              match = element.agencyId === elementId
              if (match) break
            }
            if (match) {
              const operative = element.status.translatedName === 'Operativo'
              const notOperative = element.status.translatedName === 'No operativo'
              const unknown = element.status.translatedName === 'Por identificar'
              if (operative) operativeArray.push(element)
              else if (notOperative) notOperativeArray.push(element)
              else if (unknown) unknownArray.push(element)
            }
          }

          const operativeFinal = operativeArray.length
          const notOperativeFinal = notOperativeArray.length
          const unknownFinal = unknownArray.length
          const result = {
            operative: operativeFinal,
            notOperative: notOperativeFinal,
            unknown: unknownFinal
          }
          return result
        }
      },
      {
        message: 'dataInMission',
        func: (agency, inMissionDataFullKPI, agenciesMapObj, agenciesIds) => {
          const unassignedArray = []
          const inMissionArray = []

          agenciesIds.push(agency)

          for (let index = 0; index < inMissionDataFullKPI.length; index++) {
            const element = inMissionDataFullKPI[index]
            // const match = agenciesMapObj[element.agencyId].superParentId === agency
            let match = false
            for (let indexIds = 0; indexIds < agenciesIds.length; indexIds++) {
              const elementId = agenciesIds[indexIds]
              match = element.agencyId === elementId
              if (match) break
            }
            if (match) {
              const unassigned = element.inMission === '0'
              const inMission = element.inMission === '1'
              if (unassigned) unassignedArray.push(element)
              else if (inMission) inMissionArray.push(element)
            }
          }

          const unassignedFinal = unassignedArray.length
          const inMissionFinal = inMissionArray.length
          const result = {
            unassigned: unassignedFinal,
            inMission: inMissionFinal
          }
          return result
        }
      }
    ]

    this.workerProcess = this.$worker.create(workerProcessIn)
  }
}
</script>

<style lang="stylus" scoped>
.general-bg
  background-color #424242
  border-radius 3px

.section-1
  width 360px

.section-2
  max-width 360px

.section-3
  max-width 680px
  margin-left 10px

.is-loading
  opacity: 0.3

.cancel-message
  background-color #FF5252
  color #FFEBEE
  border-radius 3px
  padding-left 10px
  font-weight 500

</style>



// WEBPACK FOOTER //
// src/components/KPI.vue